




import { mdiClose, mdiAbTesting, mdiOpenInNew } from '@mdi/js';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { keyEnumObject, ValueTypeOf } from '@berlin-front/common/utils';

const ICON_SVG_MAP = {
  mdiAbTesting,
  mdiClose,
  mdiOpenInNew,
} as const;

export const ICON_TYPE = keyEnumObject(ICON_SVG_MAP);
export type IconType = ValueTypeOf<typeof ICON_TYPE>;

/**
 * ## アイコン
 *
 * 利用できるアイコンの種類は決まっている（詳細はpropsの`type`を参照）。<br />
 *
 */
export default defineComponent({
  name: 'AppIcon',
  props: {
    /**
     * 色
     */
    color: {
      type: String,
      default: '#222',
    },

    /**
     * サイズ
     */
    size: {
      type: Number,
      default: 20,
    },

    /**
     * アイコンの種類<br/>
     * mdiClose | mdiAbTesting | mdiOpenInNew
     */
    type: {
      type: String as PropType<IconType>,
      required: true,
    },
  },

  setup(props) {
    const svgPath = computed(() => ICON_SVG_MAP[props.type]);
    return {
      svgPath,
    };
  },
});
